import { immerable } from 'immer';

interface ITraceItemEntity {
	id: number;
	code: string;
	usedDate: Date | null;
	action: string;
	details: string;
	// user: string;
	element: string;
}

const entityDefaults: ITraceItemEntity = {
	id: -1,
	code: '',
	usedDate: null,
	action: '',
	details: '',
	element: '',
};

export class TraceItemEntity implements ITraceItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public code = entityDefaults.code;
	public usedDate = entityDefaults.usedDate;
	public action = entityDefaults.action;
	public details = entityDefaults.details;
	public element = entityDefaults.element;

	public static build(params: Partial<ITraceItemEntity> = {}): TraceItemEntity {
		const entity = new TraceItemEntity();
		entity.id = params.id ?? entityDefaults.id;
		entity.code = params.code ?? entityDefaults.code;
		entity.usedDate = params.usedDate ?? entityDefaults.usedDate;
		entity.action = params.action ?? entityDefaults.action;
		entity.details = params.details ?? entityDefaults.details;
		entity.element = params.element ?? entityDefaults.element;
		return entity;
	}
}
